/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_OsteopathyInputs */

const en_service_type_osteopathy = /** @type {(inputs: Service_Type_OsteopathyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osteopathy`)
};

const pl_service_type_osteopathy = /** @type {(inputs: Service_Type_OsteopathyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osteopatia`)
};

/**
* | output |
* | --- |
* | "Osteopathy" |
*
* @param {Service_Type_OsteopathyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_osteopathy = /** @type {((inputs?: Service_Type_OsteopathyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_OsteopathyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_osteopathy(inputs)
	return en_service_type_osteopathy(inputs)
});